export enum AuthProvider {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  APPLE = 'APPLE',
}

export enum Color {
  Pink = '#e544ff',
  White = '#ffffff',
}

export enum ErrorCode {
  NotFound = 'functions/not-found',
  AlreadyExists = 'functions/already-exists',
  PermissionDenied = 'functions/permission-denied',
  FailedPrecondition = 'functions/failed-precondition',
  OutOfRange = 'functions/out-of-range',
  Internal = 'functions/internal',
}

export enum FirebaseAuthErrorCode {
  InternalError = 'auth/internal-error',
  InvalidEmail = 'auth/invalid-email',
  InvalidPassword = 'auth/invalid-password',
  UserNotFound = 'auth/user-not-found',
  EmailAlreadyExists = 'auth/email-already-exists',
}

export const FirebaseAuthError = {
  [FirebaseAuthErrorCode.InternalError]:
    // eslint-disable-next-line max-len
    'The Authentication server encountered an unexpected error while trying to process the request.',
  [FirebaseAuthErrorCode.InvalidEmail]:
    'The provided value for the email user property is invalid. It must be a string email address.',
  [FirebaseAuthErrorCode.InvalidPassword]:
    // eslint-disable-next-line max-len
    'The provided value for the password user property is invalid. It must be a string with at least six characters.',
  [FirebaseAuthErrorCode.UserNotFound]:
    'There is no existing user record corresponding to the provided identifier.',
  [FirebaseAuthErrorCode.EmailAlreadyExists]:
    'The provided email is already in use by an existing user.',
};

export enum PlanType {
  Free = 'free',
  Unlimited = 'unlimited',
  Monthly = 'monthly',
  Annual = 'annual',
}

export enum ROUTES {
  HOME = '/',
  JOIN_BETA = '/join-beta',
  TOURVIEWER = '/viewer/:id',
  PERSONAL = '/personal',
  PERSONAL_DASHBOARD = '/personal/dashboard',
  PERSONAL_TOUR_UPLOAD = '/personal/upload',
  PERSONAL_TOUR_VIEW = '/personal/dashboard/tour/:tourId',
  PERSONAL_PROFILE = '/personal/profile',
  PERSONAL_PROFILE_EDIT = '/personal/profile/edit',
  PERSONAL_INSIGHTS = '/personal/insights',
  PERSONAL_PAYMENT = '/personal/payment',
  PERSONAL_BILLING = '/personal/billing',
  SIGN_IN = '/sign-in',
  SIGN_IN_SELECTION = '/sign-in-selection',
  SIGN_UP = '/sign-up',
  SHOWCASE = '/showcase',
  SHOWCASE_DEMO = '/showcase/demo',
  SHOWCASE_TOUR_GALLERY = '/showcase/tour-gallery',
  TOURS_ERROR_403 = '/tours/403',
  INTERNAL_ERROR_500 = '/internal-error',
  TOURS_ERROR_404 = '/tours/*',
  FORGOT_PASSWORD = '/forgot-password',
  OUR_STORY = '/our-story',
  LEADERSHIP = '/leadership',
  FAQ = '/faq',
  CONTACT = '/contact',
  PRIVACY_POLICY = '/privacy-policy',
  BLOG = '/blog',
  BLOG_POST = '/blog/:id',
  JOBS = '/jobs',
  JOB = '/jobs/:id',
  NOT_FOUND = '/404',
  PRICING = '/pricing',
}

export enum WIDTH_BREAKPOINTS {
  SMALL_MOBILE = 400,
  MOBILE = 480,
  BIG_MOBILE = 600,
  TABLET = 768,
  SMALL_SCREEN = 1024,
  MEDIUM_SCREEN = 1200,
}

/**
 * Email allowlist that grants admin access in the dashboard.
 * Server-side enforcement lives in the admin-tours-api Cloud Function;
 * this list is only used client-side to decide which endpoint to call.
 */
export const ADMIN_EMAILS = ['touradmin@lavamap.com'];

export const isAdminUser = (email?: string | null): boolean =>
  !!email && ADMIN_EMAILS.includes(email.toLowerCase());
